<template>
  <div class="service">
    <span
      ref="icon"
      :class="['mozio-icon']"
    />
    <span class="mozio-name">
      <slot />
    </span>
  </div>
</template>

<script>
import { svgLoader } from '../../../services/mozio';

export default {
  name: 'Service',
  props: {
    iconUrl: {
      type: String,
      required: false,
      default: '',
    },
  },
  async mounted() {
    try {
      const svgText = await svgLoader(this.iconUrl);
      this.$refs.icon.innerHTML = svgText;
    } catch (e) {
      if (process.env.NODE_ENV === 'development') {
        console.log('Ошибка загрузки', this.iconUrl, e.message);
      }
    }
  },
};
</script>

<style lang="scss">
  .mozio-icon * {
    fill: #428bca;
    width: 12px;
    height: 12px;
    display: inline-block;
    position: absolute;
    left: -12px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
  }

  .service {
    display: inline-block;
    border-radius: 4px;
    font-size: 11px;
    line-height: 14px;
    color: #444;
    position: relative;
    height: 18px;
    text-align: left;
    border-left: 12px solid transparent;
    white-space: nowrap;
    @media screen and (min-width: $desktop-width) {
      font-size: 12px;
      line-height: 1.33;
    }
  }

  .mozio-name {
    padding: 0 5px;
  }
</style>
